"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Dialog_1 = require("./Dialog");
exports.default = Dialog_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Dialog/index.js
// module id = 458
// module chunks = 8